// import { appInsights, reactPlugin } from '../../appInsights';
// import { withAITracking } from '@microsoft/applicationinsights-react-js';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import Download from '@mui/icons-material/Download';

import JSZip from 'jszip';
import { saveAs } from 'file-saver';
import { PolicyComponents, PreconditionType, PreconditionAction, RPFileComponents } from '../../xmlParsing/interfaces';
import { generateXML } from '../../xmlParsing/generateXML';
import { generateRpXML } from '../../xmlParsing/generateRpXML';
import { ErrorReturn } from '../../utils/ErrorReturn';
// generateXML doesn't support RP files yet, so this just downloads the other ones

export interface DownloadPolicyProps {
  policies: Record<string, PolicyComponents> | undefined;
  rpPolicies: Record<string, RPFileComponents> | undefined;
}

function DownloadPolicyButton(props: DownloadPolicyProps) {
  /*********************************************************************************************
   * B2C Policy XML Download
   **********************************************************************************************/

  var prettifyXml = function (sourceXml: string) {
    var xmlDoc = new DOMParser().parseFromString(sourceXml, 'application/xml');
    var xsltDoc = new DOMParser().parseFromString(
      [
        // describes how we want to modify the XML - indent everything
        '<xsl:stylesheet xmlns:xsl="http://www.w3.org/1999/XSL/Transform">',
        '  <xsl:strip-space elements="*"/>',
        '  <xsl:template match="para[content-style][not(text())]">', // change to just text() to strip space in text nodes
        '    <xsl:value-of select="normalize-space(.)"/>',
        '  </xsl:template>',
        '  <xsl:template match="node()|@*">',
        '    <xsl:copy><xsl:apply-templates select="node()|@*"/></xsl:copy>',
        '  </xsl:template>',
        '  <xsl:output indent="yes"/>',
        '</xsl:stylesheet>',
      ].join('\n'),
      'application/xml',
    );

    var xsltProcessor = new XSLTProcessor();
    xsltProcessor.importStylesheet(xsltDoc);
    var resultDoc = xsltProcessor.transformToDocument(xmlDoc);
    var resultXml = new XMLSerializer().serializeToString(resultDoc);
    return resultXml;
  };

  const downloadXML = () => {
    if (props.policies === undefined || Object.keys(props.policies).length === 0) return;

    let zip = new JSZip();

    // let newPolicy: Record<string, PolicyComponents> | undefined = JSON.parse(JSON.stringify(props.policies));
    // // @ts-ignore
    // newPolicy['B2C_1A_TrustFrameworkExtensions']['claims'] = {
    //   newClaim: {
    //     id: 'newClaim',
    //     displayName: 'sdfsdf',
    //     userInputType: 'TextBox',
    //     dataType: 'string',
    //     restriction: [],
    //   },
    // };
    // // @ts-ignore
    // newPolicy['B2C_1A_TrustFrameworkExtensions'] = {
    //   // @ts-ignore
    //   ...newPolicy['B2C_1A_TrustFrameworkExtensions'],
    //   userJourneys: [
    //     {
    //       id: 'SignUpOrSignIn',
    //       defaultCpimIssuerTechnicalProfileReferenceId: '',
    //       authorizationTP: '',
    //       orchestrationSteps: [
    //         {
    //           order: 1,
    //           type: 'CombinedSignInAndSignUp',
    //           contentDefinitonReferenceId: 'api.signuporsignin',
    //           cpimIssuerTechnicalProfileReferenceId: '',
    //           preconditions: [],
    //           claimsProviderSelections: {
    //             displayOptions: '',
    //             providers: [
    //               {
    //                 targetClaimExchangeId: '',
    //                 validationClaimsExchange: 'LocalAccountSigninEmailExchange',
    //               },
    //             ],
    //           },
    //           claimsExchanges: [
    //             {
    //               id: 'LocalAccountSigninEmailExchange',
    //               technicalProfilerefrenceId: 'SelfAsserted-LocalAccountSignin-Email',
    //             },
    //           ],
    //           subJourneyToInvoke: '',
    //         },
    //         {
    //           order: 2,
    //           type: 'ClaimsExchange',
    //           contentDefinitonReferenceId: '',
    //           cpimIssuerTechnicalProfileReferenceId: '',
    //           preconditions: [
    //             {
    //               type: PreconditionType.CLAIM_EXIST,
    //               executeActionsIf: true,
    //               values: ['objectId'],
    //               action: PreconditionAction.SKIPORCHESTRATIONSTEP,
    //             },
    //             {
    //               type: PreconditionType.CLAIM_EQUALS,
    //               executeActionsIf: false,
    //               values: ['issuerUserId', 'abc'],
    //               action: PreconditionAction.SKIPORCHESTRATIONSTEP,
    //             },
    //           ],
    //           claimsProviderSelections: {
    //             displayOptions: '',
    //             providers: [],
    //           },
    //           claimsExchanges: [
    //             {
    //               id: 'SignUpWithLogonEmailExchange',
    //               technicalProfilerefrenceId: 'LocalAccountSignUpWithLogonEmail',
    //             },
    //           ],
    //           subJourneyToInvoke: '',
    //         },
    //         {
    //           order: 3,
    //           type: 'ClaimsExchange',
    //           contentDefinitonReferenceId: '',
    //           cpimIssuerTechnicalProfileReferenceId: '',
    //           preconditions: [],
    //           claimsProviderSelections: {
    //             displayOptions: '',
    //             providers: [],
    //           },
    //           claimsExchanges: [
    //             {
    //               id: 'sdfsf',
    //               technicalProfilerefrenceId: 'sdfsf',
    //             },
    //           ],
    //           subJourneyToInvoke: '',
    //         },
    //         {
    //           order: 4,
    //           type: 'ClaimsExchange',
    //           contentDefinitonReferenceId: '',
    //           cpimIssuerTechnicalProfileReferenceId: '',
    //           preconditions: [],
    //           claimsProviderSelections: {
    //             displayOptions: '',
    //             providers: [],
    //           },
    //           claimsExchanges: [
    //             {
    //               id: 'AADUserReadWithObjectId',
    //               technicalProfilerefrenceId: 'AAD-UserReadUsingObjectId',
    //             },
    //           ],
    //           subJourneyToInvoke: '',
    //         },
    //         {
    //           order: 5,
    //           type: 'SendClaims',
    //           contentDefinitonReferenceId: '',
    //           cpimIssuerTechnicalProfileReferenceId: 'JwtIssuer',
    //           preconditions: [],
    //           claimsProviderSelections: {
    //             displayOptions: '',
    //             providers: [],
    //           },
    //           claimsExchanges: [],
    //           subJourneyToInvoke: '',
    //         },
    //       ],
    //     },
    //   ],
    //   selfAssertedProfiles: {
    //     'SelfAsserted-Social': {
    //       id: 'SelfAsserted-Social',
    //       displayName: 'User ID signup',
    //       domain: '',
    //       description: '',
    //       protocol: [
    //         'Proprietary',
    //         'Web.TPEngine.Providers.SelfAssertedAttributeProvider, Web.TPEngine, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null',
    //       ],
    //       inputClaims: [
    //         {
    //           claimTypeReferenceId: 'newClaim',
    //           partnerClaimType: '',
    //           defaultValue: '',
    //           required: false,
    //           alwaysUseDefaultValue: false,
    //         },
    //       ],
    //       displayClaims: [],
    //       outputClaims: [],
    //       validationTechnicalProfiles: [],
    //       inputClaimsTransformations: [],
    //       outputClaimsTransformations: [],
    //       metadata: [],
    //       claimProvider: 'Self Asserted',
    //       includeTechnicalProfile: '',
    //     },
    //   },
    // };
    // console.log('newPolicy :', newPolicy);
    // consolePolicies('base', props.policies, 'B2C_1A_TrustFrameworkExtensions');
    addPolicies('base', props.policies, zip);
    addPolicies('rp', props.rpPolicies, zip);
    zip.generateAsync({ type: 'blob' }).then((blob) => {
      saveAs(blob, 'policies.zip');
    });
  };

  const addPolicies = (
    policyType: 'base' | 'rp',
    policies: Record<string, PolicyComponents> | Record<string, RPFileComponents> | undefined,
    zip: JSZip,
  ): void => {
    if (policies === undefined || Object.keys(policies).length === 0) return;
    Object.keys(policies).forEach((policyName) => {
      let policy = policies[policyName];
      let xmlString: string | ErrorReturn = '';
      if (policyType === 'base') {
        xmlString = generateXML(policy.rawXMLString, policy, policyName);
      } else if (policyType === 'rp') {
        xmlString = generateRpXML(policy.rawXMLString, policy as RPFileComponents);
      }
      if (xmlString instanceof ErrorReturn) {
        alert(xmlString.error);
        return;
      }
      xmlString = prettifyXml(xmlString);
      console.log('xmlString :', xmlString);
      zip.file(policyName + '.xml', xmlString);
    });
  };
  // code if you need to see a particular file in console
  const consolePolicies = (
    policyType: 'base' | 'rp',
    policies: Record<string, PolicyComponents> | Record<string, RPFileComponents> | undefined,
    fileName: string,
  ): void => {
    if (policies === undefined || Object.keys(policies).length === 0) return;
    Object.keys(policies).forEach((policyName) => {
      if (policyName === fileName) {
        let policy = policies[policyName];
        let xmlString: string | ErrorReturn = '';
        if (policyType === 'base') {
          xmlString = generateXML(policy.rawXMLString, policy, policyName);
        } else if (policyType === 'rp') {
          xmlString = generateRpXML(policy.rawXMLString, policy as RPFileComponents);
        }
        if (xmlString instanceof ErrorReturn) {
          alert(xmlString.error);
          return;
        }
        console.log('xmlString :', prettifyXml(xmlString));
      }
    });
  };
  return (
    <IconButton onClick={downloadXML} color="primary" aria-label="download policy">
      <Download />
    </IconButton>
  );
}

// export default withAITracking(reactPlugin, DownloadPolicyButton);
export default DownloadPolicyButton;
